
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

// Constants
import styled from 'styled-components';
import { configs } from '@constants/configs/configs';
import { TAGS_PAGINATION_THRESHOLD } from '@constants/common/miscellaneous';

const StyledButton = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    font: inherit;
    text-align: left;
`;

const TagsList = props => {
    const navigate = useNavigate();
    const intl = useIntl();

    const {
        openTagModal,
        page,
        pushToHistory,
        tags
    } = props;

    const assigneeLabel = intl.formatMessage({ id: 'ticketManagement.taglist.table.column1' });
    const workgroupLabel = intl.formatMessage({ id: 'ticketManagement.taglist.table.column2' });

    const handleRedirection = ({ target: { dataset: { name } } }) => {
        pushToHistory(
            configs.routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
            {
                prop: 'tag',
                value: name
            }
        );
    };

    const handleRedirectToWorkgroup = () => {
        navigate(configs.routes.TICKET_MGMT_MANAGE_WORKGROUP, { replace: true });
    };

    return useMemo(() => {

        const tagsArr =  tags.reduce((tagsForRender, tag, idx) => {

            if(idx < TAGS_PAGINATION_THRESHOLD * page  || idx > TAGS_PAGINATION_THRESHOLD * (page + 1) - 1) {
                return tagsForRender;
            } else {
                const {
                    id,
                    name,
                    count,
                    workGroupCount
                } = tag;

                return [
                    ...tagsForRender,
                    <div key = { id } className = 'grid-row tag-info' data-testid = "tag_list_row_data_container">
                        <div className = 'grid-col-1' data-testid = { `tag_list_row_data_${idx + 1}` }>
                            { idx + 1 }.
                        </div>
                        <StyledButton
                            className = 'grid-col-2 pointer tag-name'
                            onClick = { () => openTagModal(id, name) }
                            data-testid = { `tag_list_row_data_${name}` }
                            title = { name }
                        >
                            { name }
                        </StyledButton>
                        <div className = 'grid-col-3 tag-assignees assigned tag-text-align-center' data-testid = { `tag_list_row_data_${name}_assignee_count_id_container` }>
                            <StyledButton
                                data-name = { name }
                                onClick = { handleRedirection }
                                data-testid = { `tag_list_row_data_${name}_assignee_count_id` }
                                aria-label = { `${assigneeLabel}: ${count}` }
                            >
                                ({ count })
                            </StyledButton>
                        </div>
                        <div className = 'grid-col-1 tag-assignees assigned tag-text-align-center' data-testid = { `tag_list_row_data_${name}_workgroup_count_container` }>
                            <StyledButton
                                data-name = { workGroupCount }
                                data-testid = { `tag_list_row_data_${name}_workgroup_count` }
                                onClick = { handleRedirectToWorkgroup }
                                aria-label = { `${workgroupLabel}: ${workGroupCount}` }
                            >
                                ({ workGroupCount })
                            </StyledButton>
                        </div>
                    </div>
                ];
            }
        }, []);

        return (
            <div className = 'tag-list-scroll' data-testid = "tag_list_scroll_container">
                <div className = 'tag-list-inner'>
                    <div className = 'grid-row tag-info' data-testid = "tag_list_column_header_container">
                        <div className = 'grid-col-1' data-testid = "tag_list_column_header_id"></div>
                        <div className = 'grid-col-3' data-testid = "tag_list_column_header_name"></div>
                        <div className = 'grid-col-2 tag-name' data-testid = "tag_list_column_header_assignee">
                            <FormattedMessage id = 'ticketManagement.taglist.table.column1'/>
                        </div>
                        <div className = 'grid-col-3 tag-assignees' data-testid = "tag_list_column_header_workgroup_div">
                            <span data-testid = "tag_list_column_header_workgroup_span">
                                <FormattedMessage id = 'ticketManagement.taglist.table.column2'/>
                            </span>
                        </div>
                    </div>
                    { tagsArr }
                </div>
            </div>
        );

    }, [ tags, page, assigneeLabel, workgroupLabel ]);
};

export default TagsList;
